import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DevicesService } from 'src/app/_services/devices.service';
import { FirebaseAuthService } from 'src/app/_services/firebase-auth.service';

@Component({
  selector: 'app-help-form',
  templateUrl: './help-form.component.html',
  styleUrls: ['./help-form.component.scss']
})
export class HelpFormComponent implements OnInit {

  diviceXs: boolean;
  diviceSm: boolean;
  typesOfProblemsWithPayment:any[] = [];

  purchasesList:any[] = [];

  constructor(public firebaseAuthService: FirebaseAuthService, private devicesService: DevicesService, public router: Router) {
    this.typesOfProblemsWithPayment = [
      {
        _id: "01",
        text: "El pago se cobró 2 veces en mi tarjeta"
      },
      {
        _id: "02",
        text: "Las cuotas no coinciden con las que elegí"
      },
      {
        _id: "03",
        text: "El monto no coincide con el que vi al pagar"
      }
    ]
  }

  ngOnInit(): void {
    this.devicesService.dievice$.subscribe(res => {
      console.log("device", res)
      this.diviceXs = res === 'xs' ? true : false;
      this.diviceSm = res === 'sm' ? true : false;
    });
  }

}
